<template>
    <drawer-layout>
        <main class="bible">
            <data-gathering-header
                :title="$t('data_gatherings.finished').toString()"
                :breadcrumbs-items="breadcrumbsItems"
            />

            <data-gathering-card-list />
        </main>
    </drawer-layout>
</template>

<script>
import DrawerLayout from "@/Shared/DrawerLayout";
import DataGatheringHeader from "@/Shared/DathaGatherings/Common/DataGatheringHeader";
import IndexPage from "@/Pages/DataGathering/IndexPage";
import {i18n} from "@/i18n";

export default {
    name: "FinishedIndex",

    components: {DataGatheringHeader, DrawerLayout},

    mixins: [IndexPage],

    data() {
        return {
            breadcrumbsItems: [
                {
                    text: i18n.t('app.sidebar_items.data_sources'),
                    disabled: true,
                },
                {
                    text: i18n.t('app.sidebar_items.finished'),
                    disabled: true,
                    href: route('finished.index'),
                },
            ]
        };
    },

    mounted() {
        this.setCommonRoute('explore_records', 'finished.records');
    },
}
</script>

<style scoped>

</style>
